const SHOW_LEAGUE_PREFERENCE = false;

export { SHOW_LEAGUE_PREFERENCE };
